document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const swiper = new Swiper(".swiper-container.lp-text-images-slider_wrapper-images",      {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
          dynamicBullets: false,
        },
        slidesPerView: 1,
        spaceBetween: 14,
      }
    );
  }
});
